import React from 'react';
import { QuizOverlayProps } from '../types';

export const QuizOverlay: React.FC<QuizOverlayProps> = ({
  question,
  onAnswer,
  isVisible
}) => {
  if (!isVisible) return null;

  return (
    <div className="interactive-video-quiz-overlay">
      <div className="quiz-content">
        <h3 className="quiz-question">{question.question}</h3>
        <div className="quiz-options">
          {question.options.map((option) => (
            <button
              key={option.id}
              className="quiz-option"
              onClick={() => onAnswer(option.id)}
            >
              {option.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};